<script module>
  import "../../../widgets.pcss";
  import {tick} from "svelte";
  import WidgetUtil from "../../utils/WidgetUtil.js";

  // eenmalig bij import - alles in <script module> wordt @ import gedaan en niet @ instantiate
  tick().then(() => {
    WidgetUtil.performWidgetsSharedBootSequence(() => {
      console.log('widget boot klaar');
      // hier kan eventuele custom boot logica van dit type widget
    });
  });

</script>
<script>
  // LET OP!
  // LET OP!
  // LET OP!
  // LET OP!
  // De webshop (App.Shop.svelte) gebruikt SvelteKit voor routing.
  // De widgets zijn voor in de site, niet de reserveerstraat, en hebben geen SvelteKit.
  // Om wel componenten (en dus de look) van de reserveerstraat te kunnen gebruiken
  // delen beide lagen elkaars componenten maar zodra je hier ergens voor een widget iets import
  // dat uiteindelijk ook App.Shop import dan zal je vite build voor de widgets klappen met een rollup error.
  // LET OP!
  // LET OP!
  // LET OP!
  import {onMount} from "svelte";
  import {progress} from "../../data/progress/feature.progress.svelte.js";
  import {booking} from "../../data/booking/feature.booking.svelte.js";
  import LoadingBasicCentered from "../../components/loading/loading-basic-centered.svelte";
  import BlockNotification from "../../components/block/block-notification.svelte";
  import CalendarPrice from "../../components/calendar-price/calendar.svelte";
  import {CalendarDate} from "@internationalized/date";
  import IconInfo from "lucide-svelte/icons/info";
  import {BOOKING_TYPE_PACKAGEDEAL, ENTRY_DURATION_DAY, ENTRY_DURATION_EVENING} from "../../AppConstants.js";
  import AppConfig from "../../AppConfig.js";
  import * as actions_progress from "../../data/progress/actions_progress.svelte.js";
  import {apiCallRequestCalendarForWidgets} from "../../data/progress/actions_progress.svelte.js";
  import {getLocalTimeZone, now} from '@internationalized/date';


  onMount(() => {
    console.log("Calendar Widget Mounted");
  });

  let settings = $state({});
  let bHasBeenOpened = $state(false);

  // Listen for external events
  window.addEventListener("calendar:handleChangeTypeReq", (e) => {
    // console.log("Received handleChangeTypeReq update:", e);
    // zolang de popup niet open is (geweest) willen we ook nog geen ajax calls gaan triggeren e.d.

    if(bHasBeenOpened === true)
    {
      console.log('type verandering verwerkt');
      settings.type = e.detail;
      console.log("Received handleChangeTypeReq - bijgewerkte settings:", settings.type);
      handleWidgetOpen(settings.type);
    }
    else {
      console.log('type verandering genegeerd - widget nog niet geopend');
    }
  });

  window.addEventListener("calendar:updateSettingsAndOpen", (e) => {
    console.log("Received updateSettingsAndOpen:", e);
    settings = {...settings, ...e.detail};
    console.log("Received updateSettingsAndOpen - bijgewerkte settings:", settings.type);
    bHasBeenOpened = true;
    handleWidgetOpen(settings.type);
  });

  let handleWidgetOpen = (sType) =>
  {
    // om te beinvloeden waarvan apiCallRequestCalendar de prijskalender op gaat vragen moeten we een aantal waardes in de store
    // opslaan zodat het gedrag lijkt op de reserveerstraat
console.log('type check', sType);
    switch ( sType )
    {
      case 'sa':
        booking.iUseThisEntryIDForFirstPerson = false;
        booking.sPreferredPartOfTheDay = false;
        booking.bShowListOfPackageDeals = true;
        booking.iPreselectedPackageDealID = AppConfig.iFallbackPackageDealWithoutTreatmentsID;
        break;
      case 'se':
        booking.iUseThisEntryIDForFirstPerson = AppConfig.iDefaultEntreeID;
        booking.iPreselectedPackageDealID = 0;
        booking.bShowListOfPackageDeals = false;
        booking.sPreferredPartOfTheDay = ENTRY_DURATION_DAY;
        break;
      case 'ae':
        booking.bShowListOfPackageDeals = false;
        booking.sPreferredPartOfTheDay = ENTRY_DURATION_EVENING;
        booking.iUseThisEntryIDForFirstPerson = AppConfig.aEntreeAvondExternalIDs[0];
        booking.iPreselectedPackageDealID = 0;
        break;
      default:
      // niets
    }

    actions_progress.apiCallRequestCalendarForWidgets();
  }

  // Externe CSS
  let bIsCSSLoaded = $state(false);

  function loadTheme()
  {
    // return RoutingUtil.appendWebshopStyleSheetToPage();
  }

  $effect(() => {
    // Deze constructie zorgt ervoor dat we eerst op basis van host de goede themed css file inladen
    // en op de body tag de goede theme class zetten (is-devarana etc)
    // (wat we willen om de css-vars vanuit SCSS hierheen te halen en te laden VOOR we de Svelte componenten starten).
    if ( !bIsCSSLoaded )
    {
      // loadTheme().then(() => {
      bIsCSSLoaded = true;
      // RoutingUtil.mountApps();
      // });
    }
  });

  let oInitialDate;
  let oSelectedDate = $state(false);

  if ( booking.sArrivalDate !== false )
  {
    oInitialDate = new CalendarDate(booking.iArrivalYear, booking.iArrivalMonth, booking.iArrivalDay);
    oSelectedDate = oInitialDate;
  }

  function setInfoText(oDateConfig)
  {
    if ( oDateConfig?.i?.info )
    {
      progress.sCalendarInfo = oDateConfig.i.info;
    }
    else
    {
      progress.sCalendarInfo = false;
    }
  }

  let date = new Date();
  let year = date.getFullYear();
  let month = ("0" + (date.getMonth() + 1)).slice(-2); // Months are zero based
  let day = ("0" + date.getDate()).slice(-2);
  //const sToday = `${year}-${month}-${day}`;
  const sToday = `${day}-${month}-${year}`;

  let oPlaceholder = new CalendarDate(year, month, day);

  let oLastProcessedDate = $state(oInitialDate);

  $effect(() => {
    if ( typeof oSelectedDate !== 'undefined'
      && oSelectedDate !== ""
      && oSelectedDate !== false
      && oSelectedDate !== oInitialDate
      && oSelectedDate !== oLastProcessedDate
    )
    {
      oLastProcessedDate = oSelectedDate;

      // 31-05-2025
      let sDate = oSelectedDate.day + '-' + oSelectedDate.month + '-' + oSelectedDate.year;
      document.querySelector('#hiddenDatePicker').value = sDate;

      console.log('er is een andere datum gekozen: ' + sDate)

      // Define the weekday and month names in Dutch
      const weekdays = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];
      const months = ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'];

      // Extract date components
      let weekday = weekdays[oSelectedDate.toDate(getLocalTimeZone()).getDay()];
      let day = oSelectedDate.day;
      let month = months[oSelectedDate.month - 1]; // months are 1-indexed in CalendarDateTime
      let year = oSelectedDate.year;

      // Format the date string
      let sFormattedDate = `${weekday}, ${day} ${month} ${year}`;

      console.log(sFormattedDate);

      // Set the value of the input element
      document.querySelector('.tooltip--calendar-home').value = sFormattedDate;

      // booking_actions.setArrivalDate(oSelectedDate.day, oSelectedDate.month, oSelectedDate.year);
      setInfoText(progress.aCalendarDates[oSelectedDate.year + '-' + oSelectedDate.month + '-' + oSelectedDate.day]);

      const TipElem = document.querySelector('.tooltip--calendar-home');

      if ( TipElem !== null )
      {
        const TipInst = TipElem._tippy;
        TipInst.hide();
      }
    }

    // bij het openen van de kalender ook even checken of er voor de huidige dag een infotekst is
    if ( typeof progress.aCalendarDates[booking.iArrivalYear + '-' + booking.iArrivalMonth + '-' + booking.iArrivalDay] !== "undefined" )
    {
      setInfoText(progress.aCalendarDates[booking.iArrivalYear + '-' + booking.iArrivalMonth + '-' + booking.iArrivalDay]);
    }
  });

  function handleNextClick()
  {
    //progress_actions.goToNextStep();
  }

</script>

<svelte:boundary onerror={(e) => {console.log('Error in Widget.CalendarHome)', e)}}>
  <div class="widget widget-calendar">
    <div class="calendar-container">
      {#if progress.aCalendarDates.length === 0}
        <div style="height: 200px; padding-top: 40px;">
          <LoadingBasicCentered/>
        </div>
      {:else}
        <div class="calendar">
          <div class="calendar-and-info">

            <CalendarPrice
              type="single"
              placement="widget"
              placeholder={oPlaceholder}
              bind:value={oSelectedDate}
              class="rounded-md border"
            />
            {#if progress.sCalendarInfo}
              <BlockNotification sType="neutral">
                <div class="info-container">
                  <div class="icon">
                    <IconInfo style="width: 23px; height: 23px;"/>
                  </div>
                  <div class="txt">{progress.sCalendarInfo}</div>
                </div>
              </BlockNotification>
            {/if}
          </div>
          <div class="calendar-legend">
            {#if settings.type === 'sa'}
              <div>Arrangementen zijn beschikbaar vanaf deze prijs.</div>
            {/if}
            <div class="calendar-legend__inner">
              <div class="calendar-legend__block calendar-legend__block--unavailable"></div>
              {#if booking.bIsAction === true}
                <span>Volgeboekt of niet beschikbaar voor deze actie</span>
              {:else}
                <span>Volgeboekt / gesloten</span>
              {/if}
            </div>
            <div class="calendar-legend__inner">
              <div class="calendar-legend__block calendar-legend__block--available "></div>
              <span>Beschikbaar</span>
            </div>
            <i class="f-size-80"></i>
          </div>
        </div>
      {/if}
    </div>

  </div>
</svelte:boundary>

<style>
  .widget-calendar {
    padding: 16px;
    /*background-color: #e80000;*/
    background-color: white;
    border-radius: 8px;
    margin-bottom: 16px;
    min-width: 400px;
  }

  .calendar-container {
    margin-right: 0;
  }

  /*de container waar de kalender (+info) en de legenda in zitten*/
  .calendar {
    width: 100%;
    container-type: inline-size;
    container-name: kalender;
    /*--calendar-day-padding: 20px;*/
    display: flex;
    justify-content: space-evenly;
    flex-direction: column;

    @container maincontainer (min-width: 700px) {
      flex-direction: row;
    }
  }

  .calendar-and-info {
    flex-grow: 1;
  }

  .calendar-legend {
    width: 100%;
    container-type: inline-size;
    container-name: legendcontainer;
    /*background: yellow;*/
    display: flex;
    justify-content: start;
    flex-direction: column;
    gap: 1rem;
    padding: 1em;

    @container maincontainer (min-width: 700px) {
      /* naast de kalender */
      max-width: 200px;
    }
  }

  .calendar-legend__inner {
    display: flex;
    flex-direction: row;
    gap: 5px;
    align-items: flex-start;

    span {
      margin-left: 10px;
      line-height: 2em;
    }

    &:not(:last-child) {
      /*flex-grow: 0.5;*/
    }
  }

  .calendar-legend__block {
    margin-top: 4px;
    height: 28px;
    width: 28px;
    border: 1px solid var(--hmk-clr-theme-calendar-legend-border);

    &.calendar-legend__block--available {
      background-color: var(--hmk-clr-theme-calendar-available-bg);
    }

    &.calendar-legend__block--unavailable {
      background-color: var(--hmk-clr-theme-calendar-unavailable-bg);
    }

    &.calendar-legend__block--special {
      background-color: var(--hmk-clr-theme-calendar-special-bg);
    }

    &.calendar-legend__block--action {
      background-color: var(--hmk-clr-theme-calendar-action-bg);
    }
  }

  .info-container {
    margin-top: 5px;
    display: flex;
    flex-direction: row;
    padding: 20px 5px 20px 0;
  }

  .icon {
    padding-right: 20px;
    padding-top: 4px;
  }

  .cta-container {
    display: flex;
    flex-direction: row;
    justify-content: end;
    margin-bottom: 20px;
  }

</style>
